import { STATUS_DAIR } from "../../../../controllers/ClientController";

//Índices posicionais usados historicamente pelo DairTab para os status de fallback.
//Ficam como último recurso: a resolução preferida é por short_name, que não depende
//da ordenação de status_dair (order_by) continuar a mesma.
const FALLBACK_INDEX_PENDENT = 0;  //EXTRATOS PENDENTES
const FALLBACK_INDEX_REGULAR = 10; //REGULAR

const SHORT_NAME_PENDENT = 'EPEND';
const SHORT_NAME_REGULAR = 'REGUL';

function findStatus(statusesDair, shortName, fallbackIndex) {
    if (!statusesDair || !statusesDair.length) return null;
    return statusesDair.find(el => el.short_name === shortName) || statusesDair[fallbackIndex] || null;
}

//O id do status gravado vem de status_dair_id, mas updateViewStatusDairClient (DairTab)
//faz a atualização otimista reescrevendo apenas dair_name/dair_short_name/dair_color e
//deixa status_dair_id com o valor antigo. Por isso o short_name tem precedência aqui:
//sem ele, um id obsoleto voltaria depois de uma troca de status.
function resolveStatusId(monthEntry, statusesDair) {
    const bySortName = monthEntry.dair_short_name
        && statusesDair
        && statusesDair.find(el => el.short_name === monthEntry.dair_short_name);

    if (bySortName) return bySortName.id;

    return monthEntry.status_dair_id != null ? monthEntry.status_dair_id : null;
}

/**
 * Resolve o status DAIR exibido para um mês, aplicando os mesmos fallbacks da grade.
 *
 * Usada pela aba DAIR (célula da tabela) e pela aba Marketing (recorte de e-mails):
 * é o que garante que as duas telas concordem sobre o status de um cliente no mês.
 *
 * Mantém, de propósito, a mutação de clientRow[month] no caso 'pendent': o DairTab
 * passa o clientRow adiante para a troca de status, e updateViewStatusDairClient
 * grava em clientRow[month].dair_name — o que exige que a célula já seja objeto.
 *
 * @param {object} clientRow linha vinda de doGetStatusClientsByYear
 * @param {number} month 1..12
 * @param {Array} statusesDair lista completa de status_dair (ordenada por order_by)
 * @returns {{id: number, name: string, short_name: string, color: string}|null}
 *          null quando o mês não é aplicável ao cliente (célula não clicável)
 */
export function resolveMonthStatusDair(clientRow, month, statusesDair) {

    if (!clientRow) return null;
    if (clientRow[month] === STATUS_DAIR.unneeded) return null;

    if (clientRow[month] === STATUS_DAIR.pendent) {
        const statusPendent = findStatus(statusesDair, SHORT_NAME_PENDENT, FALLBACK_INDEX_PENDENT);
        if (!statusPendent) return null;

        clientRow[month] = {
            status_dair_id: statusPendent.id,
            dair_name: statusPendent.name,
            dair_short_name: statusPendent.short_name,
            dair_color: statusPendent.color,
        };

        return {
            id: statusPendent.id,
            name: statusPendent.name,
            short_name: statusPendent.short_name,
            color: statusPendent.color,
        };
    }

    if (clientRow[month]) {
        const monthEntry = clientRow[month];
        return {
            id: resolveStatusId(monthEntry, statusesDair),
            name: monthEntry.dair_name,
            short_name: monthEntry.dair_short_name,
            color: monthEntry.dair_color,
        };
    }

    const statusRegular = findStatus(statusesDair, SHORT_NAME_REGULAR, FALLBACK_INDEX_REGULAR);
    if (!statusRegular) return null;

    return {
        id: statusRegular.id,
        name: statusRegular.name,
        short_name: statusRegular.short_name,
        color: statusRegular.color,
    };
}
